import moment from 'moment';
import momentTz from 'moment-timezone';

import removeCharacter from '@src/utils/removeCharacter';

const displayTimezone = (utcTime) => {
    const momentTimeZone = momentTz.tz.guess();
    const timeZone = momentTz.tz(utcTime, momentTimeZone).zoneAbbr();
    return removeCharacter(timeZone, 1);
};

export default displayTimezone;

const formDateShort = (dateStr) => {
    const givenDate = new Date(`${dateStr}T00:00:00`);
    const day = givenDate.getDate();
    const month = givenDate.getMonth();
    const year = givenDate.getFullYear().toString().substr(-2);
    return `${month + 1}/${day}/${year}`;
};

const formatDuration = (seconds) => {
    const secs = Number(seconds);

    const h = Math.floor(secs / 3600);
    const m = Math.floor(secs % 3600 / 60);
    // const s = Math.floor(secs % 3600 % 60);

    if (h > 0) {
        const hours = h === 1 ? `${h} hour` : `${h} hours`;
        if (m > 0) {
            const minutesAnd = m === 1 ? ' and 1 minute' : ` and ${m} minutes`;
            return `${hours}${minutesAnd}`;
        }

        return `${hours}`;
    }

    const minutes = m === 1 ? '1 minute' : `${m} minutes`;
    return `${minutes}`;
};

const defaultTimezone = 'America/New_York';

const formatDate = (dateStr, dateFormat = 'MMMM D, YYYY') => {
    return momentTz.tz(dateStr, defaultTimezone).format(dateFormat);
};

const isInFuture = (dateStr) => {
    if (!dateStr) {
        return false;
    }

    const date = moment(dateStr);
    const today = moment(new Date());

    if (!date || !today) {
        return false;
    }

    return date.isAfter(today, 'day');
};

const isInPast = (dateStr) => {
    if (!dateStr) {
        return false;
    }

    const date = moment(dateStr);
    const today = moment(new Date());

    if (!date || !today) {
        return false;
    }

    return date.isBefore(today, 'day');
};

export {
    displayTimezone,
    formDateShort,
    formatDuration,
    formatDate,
    isInFuture,
    isInPast,
};
